
import Vue from "vue"
import { VueConstructor } from "vue/types/umd"
import { EventBus } from "@/plugins/eventBus"
import axios from "axios"

export default (Vue as VueConstructor<Vue>).extend({
  name: "AddCommentDialog",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    selectedSW: {
      type: Array as () => string[],
      required: true
    }
  },
  data: () => ({
    loading: false,
    commentText: ""
  }),
  computed: {
    inputValue: {
      get(): boolean {
        return this.value
      },
      set(val: boolean) {
        this.$emit('input', val)
      }
    },
    selectedWorkersText(): string {
      const count = this.selectedSW.length;
      return count + ' ' + this.$vuetify.lang.t(`$vuetify.${count > 1 ? 'workers' : 'worker'}`);
    },
    requiredRule() {
        return (v: string) => !!v || this.$vuetify.lang.t('$vuetify.comment_required')
      },
  },
  methods: {
    checkSelection() {
      // Display snackbar error and hide component if no super_worker in selection
      if (this.selectedSW.length === 0) {
        EventBus.$emit('snackbar', { message: this.$vuetify.lang.t('$vuetify.empty_selection'), color: 'error' })
        this.inputValue = false
        return false
      }
      return true
    },
    cancel() {
      (this.$refs.form as any)?.reset();
      this.inputValue = false;
    },
    async submit() {
      if (!this.commentText) return;
      
      this.loading = true;
      
      try {
        const body = {
          id: this.selectedSW,
          add_comment: this.commentText
        };
        
        // Make API request
        await axios.post('/v1/workers/action', body);
        
        // Show success message
        EventBus.$emit('snackbar', {
          message: this.$vuetify.lang.t('$vuetify.success_add_comment'),
          color: 'success'
        });
        
        // Close dialog
        this.inputValue = false;
        
        // Emit completed event so parent can refresh data if needed
        this.$emit('completed');
      } catch (error) {
        EventBus.$emit('snackbar', { axiosError: error });
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    inputValue(val: boolean) {
      if (val === true) {
        // Check if selection is empty when dialog opens
        if (!this.checkSelection()) return;
        
        // Reset the comment text when dialog opens
        this.commentText = "";
        // Reset form validation when dialog closes
        (this.$refs.form as any)?.reset();
      }
    }
  }
})
